import Param from './param';
import Util from './module/libs/util';
import Splash from './module/libs/splash';
import newsManager from './module/libs/news';
import effectManager from './module/effect';
import transitionManager from './module/transition/manager';
import lowlayerManager from './page/lowlayer';
import globalNavi from './module/global/globalNavi';
import keyVisual from './module/global/keyvisual';
import commonManager from './page/common';
import topManager from './page/top';
import smoothScrollManager from './module/scroll/scrollManager';
import MouseManager from './module/mouse/mouseManager';
import contactManager from './module/libs/contact';
import GoogleMapManager from './module/libs/googlemap';

const param = new Param();
const util = new Util();
let splash = false;
let news;
let effect = new effectManager();
let scroll = new smoothScrollManager();
let mouse = new MouseManager();
let transition = new transitionManager();
let lowlayer;
let gmap;
let contact;
let pageCommon = new commonManager(effect);
let kv = new keyVisual(effect);
let top = false;
const gNavi = new globalNavi();

const stats = new Stats();
stats.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
// document.body.appendChild( stats.dom );

let pageID,prevPageID = false;
let executionType = "landing"; /* 実行タイミングの制御用 */
let fpsRate = 0;
let $headerBgColor;
let _y = 0;
let _touch = {
    flg:false,
    inc:0,
    nowInc:0,
}

let loaded = false;
let bannerShow = false;

/* ---------------------------------------------------

  -- render

 --------------------------------------------------- */

let render = function () {
    if(!requestAnimationFrame){
        setTimeout(function () {
            render;
        },1000/60);
    }else{
        requestAnimationFrame(render);
    }

    fpsRate = util.updateTimeRatio();

    stats.begin();

    scroll.move(fpsRate,bannerShow);
    mouse.move();
    if(kv.status.execution) executionType = "kv";

    if(pageID!="top"){
        if(lowlayer) if(lowlayer.tab) if(lowlayer.tab.resizeFlg){
            lowlayer.tab.resizeFlg = false;
            scroll.resize(param.displayType);
        }
    }else{
        top.render(scroll);
        kv.render(scroll.inc);
    }

    stats.end();

}

let loadRender = function () {
    if(splash.status.done) return;
    if (!requestAnimationFrame) {
        setTimeout(function () {
            loadRender;
        }, 1000 / 60);
    } else {
        requestAnimationFrame(loadRender);
    }
    splash.render();
}

/* ---------------------------------------------------

  --

 --------------------------------------------------- */


let common = function () {

    // TweenLite.set(window,{scrollTo:{y:0,autoKill:false}});

    pageID = document.getElementsByTagName("body")[0].getAttribute("id");
    if(!prevPageID) prevPageID = pageID;

    scroll.init(pageID);

    let _$html =  document.getElementsByTagName("html")[0];

    if(pageID!=="top"){
        lowlayer = new lowlayerManager();
        lowlayer.init(pageID, scroll);
        _$html.classList.add("l-lowlayer");
    }else{
        _$html.classList.remove("l-lowlayer");
    }

    if(executionType != "landing") resize();
    transition.update(pageID,prevPageID)

    setTimeout(function(){
        pageCommon.show(splash,scroll.inc);
        prevPageID = pageID;
        resize();
        setTimeout(function(){
            loaded = true;
        },1e3);
    },1e3);

    switch(pageID) {
        case "top":
            gmap = new GoogleMapManager(pageID);
            break;
        case "map":
            gmap = new GoogleMapManager(pageID);
            break;
        case "contact":
            contact = new contactManager();
            break;
        case "news":
            news = new newsManager(scroll,param.displayType);
            break;
    }


    pageManager(pageID);



}

let pageManager = function(){

    switch(pageID){
        case "top":
            top = new topManager(effect);
            setTimeout(() => {
                gmap.init();
            },1e3);
            break;
        case "map":
            setTimeout(() => {
                gmap.init();
            },1e3);
            break;
        case "contact":
            contact.init();
            break;
        case "news":
            news.init();
            break;
    }

}

let resize = function () {

    param.displayType = ( window.innerWidth>param.breakpoint )?"pc":"sp";


    kv.resize();
    gNavi.resize();

    if(pageID!="top"){
        lowlayer.resize(param.displayType);
    }

    /* 画面が縦横どちらに広いか判定 */

    if(window.innerWidth > window.innerHeight){
        $headerBgColor.classList.add("is-w");
        $headerBgColor.classList.remove("is-h");
    }else{
        $headerBgColor.classList.add("is-h");
        $headerBgColor.classList.remove("is-w");
    }

    scroll.resize(param.displayType);
    if(splash) splash.resize(param.displayType);

}


/* ---------------------------------------------------

  -- load

 --------------------------------------------------- */

// effect.svgInit();

window.addEventListener("load", ()=> {
// Pace.on("done", function () {

    TweenMax.set(document.getElementById("l-header"),{y:-100,opacity:1});

    $headerBgColor = document.getElementById("l-header-navi-bg-color");
    executionType = "landing";
    TweenMax.set(document.getElementById("l-root"),{
        css:{
            'visibility':'visible'
        }
    });
    transition.init();
    common();
    pageCommon.init(pageID,executionType,splash);
    gNavi.init(scroll);
    kv.init();
    // $('html,body').animate({ scrollTop: 0 }, '1');
    render();

    if(!top) top = new topManager(effect);
    top.init(scroll);

});

if ((navigator.userAgent.indexOf('Android') != -1)) {
    let _banner = document.getElementById("c-android-banner");
    let _bannerClose = document.getElementById("c-android-banner-close");
    let _bannerOpen = document.getElementById("c-android-banner-open");
    if ($.cookie('bnrRead') != 'on') {
        _banner.style.display = "block";
        TweenMax.set(['#l-header','#l-header-navi'], {
            top:_banner.clientHeight
        });
        TweenMax.set('#l-kv', {
            top:_banner.clientHeight/2
        });
        bannerShow = true;
    }
    _bannerOpen.addEventListener("click",(e)=>{
        bannerShow = false;
        TweenMax.set(_banner, {
            display:'none'
        });
        TweenMax.set(['#l-header','#l-header-navi','#l-kv'], {
            delay:0.3,
            top:0,
            onComplete:() =>{
                $.cookie('bnrRead', 'on', { //cookieにbnrReadという名前でonという値をセット
                    expires: 14, //cookieの有効日数
                    path:'/' //有効にするパス
                });
                location.href = 'https://play.google.com/store/apps/details?id=jp.hellocycling.hellocycling&hl=ja';
            }
        });
    });
    _bannerClose.addEventListener("click",(e)=>{
        bannerShow = false;
        TweenMax.set(_banner, {
            display:'none'
        });
        TweenMax.set(['#l-header','#l-header-navi','#l-kv'], {
            delay:0.3,
            top:0,
            onComplete:() =>{
                $.cookie('bnrRead', 'on', { //cookieにbnrReadという名前でonという値をセット
                    expires: 1, //cookieの有効日数
                    path:'/' //有効にするパス
                });
            }
        });
    });
}

if(document.getElementsByTagName("body")[0].getAttribute("id") == "top" && $.cookie("access") == undefined) {
    $.cookie("access","onece");
    splash = new Splash();
    $(document).ready(() => {
        splash.init(param.displayType);
        loadRender();
    });
    Pace.on('done', () => {
        splash.done();
    });
}else{
    $('#l-splash').remove();
}

/* ---------------------------------------------------

  -- event

 --------------------------------------------------- */
// let _mousewheelevent = "onwheel" in document.createElement("div") ? "wheel" :  document.onmousewheel !== undefined ? "mousewheel" : "DOMMouseScroll";

let mousewheelevent = "onwheel" in document.createElement("div") ? "wheel" :  document.onmousewheel !== undefined ? "mousewheel" : "DOMMouseScroll";

window.addEventListener(mousewheelevent,(e)=>{

    // console.log(e);

    if(pageID != "top") return;
    // let _delta = e.deltaY ? -(e.deltaY) : e.wheelDelta ? e.wheelDelta : -(e.detail);
    // top.wheel(_delta);

    if(!loaded){
        e.preventDefault();
    }
});

// document.querySelectorAll("a").addEventListener("click",function (e) {
//     executionType = "pjax";
//     e.target.classList.add("is-none"); /* 非同期遷移用にダブルクリックの対策 */
// })



window.addEventListener("scroll", function (e) {

    // if(scroll.auto.mvFlg) e.preventDefault();

    _y = window.pageYOffset || document.documentElement.scrollTop;
    scroll.update(_y,"");
    if(_y < 100) _touch.flg = false;
});
window.addEventListener("mousemove",function (e) {

    let _x = e.clientX;
    let _y = e.clientY;


    mouse.update(_x,_y);

});

if(Useragnt.pc){
}else{
    // window.addEventListener("deviceorientation",function (e) {
    //
    //
    //     const _degtorad = Math.PI / 180;
    //
    //     const _x = e.beta ? e.beta * _degtorad : 0;
    //     const _y = e.gamma ? e.gamma * _degtorad : 0;
    //     const _z = e.alpha ? e.alpha * _degtorad : 0;
    //
    //     const _sX = Math.sin(_x);
    //     const _sY = Math.sin(_y);
    //
    //
    //     // mouse.update(_sX,_sY);
    //
    // });
}

window.addEventListener("resize",function (e) {
    executionType = "resize";
    resize();

});
window.addEventListener("onorientationchange",function (e) {
    executionType = "onorientationchange";
    resize();
});

//android用
if(document.getElementsByTagName("body")[0].getAttribute("id") == "top" && navigator.userAgent.indexOf('Android') > 0){
    document.addEventListener("touchstart",function (e) {
        _touch.inc = e.touches[0].pageY;
    },{ passive: false });
    document.addEventListener("touchmove",function (e) {
        if(!_touch.flg){
            e.preventDefault();
        }
    }, { passive: false });
    document.addEventListener("touchend",function (e) {
        if(!_touch.flg){
            _touch.nowInc = e.changedTouches[0].pageY;
            if (_touch.inc > _touch.nowInc && _touch.inc - _touch.nowInc > 50) {
                TweenMax.to(window, 0.5, {
                    scrollTo:{
                        y:100,
                        autoKill:false
                    }
                });
                setTimeout(() => {
                    _touch.flg = true;
                },10e2);
            }
        }
    });
}

/* ---------------------------------------------------

  -- PJAX

 --------------------------------------------------- */

Barba.Pjax.start();
Barba.Prefetch.init();
let pjaxHref = '';

var PageTransition = Barba.BaseTransition.extend({
    start: function() {

        /* 画面遷移する際に発火 */

        // console.log("start")

        Promise
            .all([this.newContainerLoading, this.out()])
            .then(this.show.bind(this));
    },

    out: function() {

        /* 画面遷移時に消える処理 */
        if (pjaxHref.indexOf('?') != -1 || pjaxHref.indexOf('#') != -1) {
            TweenMax.to(document.getElementById("l-root"),0.3,{opacity:0,
                onComplete:()=>{
                    pageCommon.hide();
                    splash = false;
                }
            })
        }else{
            TweenLite.to(window, 0.1,{scrollTo:{y:0,autoKill:false}});
            TweenMax.to(document.getElementById("l-body"),0.3,{opacity:0})
            pageCommon.hide();
            splash = false;
        }
    },

    show: function() {

        /* 画面遷移時に表示される処理 */

        var $el = $(this.newContainer);

        let _delay = 5e2;
        if ( pjaxHref.indexOf('?') != -1) {
            _delay = 0;
            TweenMax.to([document.getElementById("l-root"),document.getElementById("l-kv")],0.2,{delay:2,opacity:1})
        }else if(pjaxHref.indexOf('#') != -1){
            _delay = 0;
            TweenLite.to(window, 0.1,{scrollTo:{y:0,autoKill:false}});
            TweenMax.to([document.getElementById("l-root"),document.getElementById("l-kv")],0.2,{delay:2,opacity:1})
        }

        // let _delay = (executionType==="pjax")?2e3:1e2;
        setTimeout(()=> {
            $(this.oldContainer).hide();
            $("body").attr("id",pageID);
            this.done();
            common();
            pageCommon.init(pageID,"pjax");
            $("a").removeClass("is-none"); /* 非同期遷移時につけているclassを削除 */
            TweenMax.to(document.getElementById("l-body"),0.2,{opacity:1})
            TweenMax.set($el,{opacity : 1});
        },_delay);

    }
});



Barba.Dispatcher.on('linkClicked', function() {
    //console.log("開始");

});
Barba.Dispatcher.on('newPageReady', function(currentStatus, prevStatus, HTMLElementContainer, newPageRawHTML) {


    /* ページ情報取得 */
    pageID = currentStatus.namespace;

    /* head内書き換え */
    var head = document.head;
    var newPageRawHead = newPageRawHTML.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
    var newPageHead = document.createElement('head');
    newPageHead.innerHTML = newPageRawHead;

    var removeHeadTags = [
        "meta[name='keywords']"
        ,"meta[name='description']"
        ,"meta[property^='og']"
        ,"meta[name^='twitter']"
        ,"meta[itemprop]"
        ,"link[itemprop]"
        ,"link[rel='prev']"
        ,"link[rel='next']"
        ,"link[rel='canonical']"
    ].join(',');
    var headTags = head.querySelectorAll(removeHeadTags)
    for(var i = 0; i < headTags.length; i++ ){
        head.removeChild(headTags[i]);
    }
    var newHeadTags = newPageHead.querySelectorAll(removeHeadTags)

    for(var i = 0; i < newHeadTags.length; i++ ){
        head.appendChild(newHeadTags[i]);
    }

    // executionType = "pjax";

    //アナリティクスに送信
    // ga('send', 'pageview', window.location.pathname.replace(/^\/?/, '/') + window.location.search);

    /* html書き換え */

});

Barba.Pjax.getTransition = function() {
    // console.log("getTransition");
    return PageTransition;
};
Barba.Dispatcher.on("load", function() {
    // console.log("test");
});

Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
Barba.Pjax.preventCheck = function(evt, element) { //ハッシュが含まれていてもbarbaが機能するように

    if(element==undefined) return;
    pjaxHref = element.getAttribute('href');
    if (element.getAttribute('href') && element.getAttribute('href').indexOf('#') > -1)
        return true;
    else
        return Barba.Pjax.originalPreventCheck(evt, element)
};

